import { defineStore } from 'pinia'
import { useLocalStorage } from '@vueuse/core/index.cjs';

const usuario = (params = {}) =>{
    return{
        id: params.id || "",
        nome: params.nome || "",
        login: params.login || "",
        grupoId: params.grupoId || "",
        grupoNome: params.grupoNome || "",
        filialAtiva: params.filialAtiva || "",
        filiais: params.filiais || [],
        tokenAcesso: params.tokenAcesso || "",
        tokenAPI: params.tokenAPI || "",
    }
}

const useUsuarioStore = defineStore('UsuarioStore', {
    state: () => ({
        usuario: useLocalStorage("UsuarioStore", usuario())
    }),
    actions: {
        save(params) {
            this.usuario = usuario(params);
        },
        setFilialAtiva(filialAtiva){

            this.usuario = usuario({
                ...this.usuario,
                filialAtiva: filialAtiva,
            });

        },
        clear() {
            this.usuario = usuario();
        },
    },
});

export default useUsuarioStore